const YOUTUBE_ID_REGEX = /^[A-Za-z0-9_-]{11}$/;

// Accepts a bare 11-char ID or any YouTube URL shape: youtu.be/, watch?v=,
// embed/, v/, shorts/. Returns null if nothing usable is found.
export function parseYoutubeId(input: string): string | null {
  if (!input) return null;
  const trimmed = input.trim();

  if (YOUTUBE_ID_REGEX.test(trimmed)) return trimmed;

  const match = trimmed.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:[^&]*&)*v=|embed\/|v\/|shorts\/))([A-Za-z0-9_-]{11})/,
  );
  return match ? match[1] : null;
}

export function youtubeIdToUrl(id: string | null | undefined): string {
  return id ? `https://www.youtube.com/watch?v=${id}` : '';
}
